module.exports = "<div class=\"loading\" ng-show=\"$ctrl.isLoading\">\n  <div>\n    <i class=\"fa fa-circle-o-notch\" aria-hidden=\"true\"></i>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/lib/loading/loading.html
// module id = 42
// module chunks = 0